import AppDispatcher from '../dispatcher/app-dispatcher'


var UploadActions = {
    addImagesToUpload: function (imageCount) {
        AppDispatcher.handleViewAction({
            actionType: 'addImagesToUpload',
            imageCount: imageCount
        });
    },
    incrementUpload: function (imageCount) {
        AppDispatcher.handleViewAction({
            actionType: 'incrementUploadCount',
            imageCount: imageCount
        });
    },
    startUpload: function () {
        AppDispatcher.handleViewAction({
            actionType: 'startUpload'
        });
    },
    addImageToStore: function (image) {
        AppDispatcher.handleViewAction({
            actionType: 'addImageToStore',
            image: image
        });
    },
    updateStatistics: function (statistics) {
        AppDispatcher.handleViewAction({
            actionType: 'updateStatistics',
            statistics: statistics
        });
    },

    /**
     * @param {OpeImageLocal[]} images
     */
    addImagesToStore: function (images) {
        AppDispatcher.handleViewAction({
            actionType: 'addImagesToStore',
            images: images
        });
    },
    removeImageFromStore: function (imageId) {
        AppDispatcher.handleViewAction({
            actionType: 'removeImageFromStore',
            imageId: imageId
        });
    },
    removeImagesFromUpload: function (imageCount, removeRegistered, removeUploaded) {
        AppDispatcher.handleViewAction({
            actionType: 'removeImagesFromUpload',
            imageCount: imageCount,
            removeRegistered: removeRegistered,
            removeUploaded: removeUploaded
        });
    },
    addUploadError: function (error) {
        AppDispatcher.handleViewAction({
            actionType: 'addUploadError',
            error: error
        });
    },
    removeUploadError: function (index) {
        AppDispatcher.handleViewAction({
            actionType: 'removeUploadError',
            index: index
        });
    },
    incrementRegisterCount: function () {
        AppDispatcher.handleViewAction({
            actionType: 'incrementRegisterCount'
        });
    },
    addUploadWarning: function (imageId, warning) {
        AppDispatcher.handleViewAction({
            actionType: 'addUploadWarning',
            imageId: imageId,
            warning: warning
        });
    },
    setServerData: function (imageId, data) {
        AppDispatcher.handleViewAction({
            actionType: 'setServerData',
            imageId: imageId,
            data: data
        });
    }
};

export default UploadActions;
